var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',_vm._l((_vm.blocks),function(block,index){return _c('div',{key:index},[_c(((block.type) + "Block"),{tag:"component",attrs:{"block":block}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }